import * as React from 'react';
import styled from 'styled-components';
import { __ } from 'react-i18n';
import { FormInput } from '../../Form/FormInput';
import { FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { rem } from 'polished';
import { prop } from '../../../../utilities';

interface Props {
  initialInfo: {
    email: string;
    phone: string;
  };
  onBlur: (data: any) => void;
  formProblems: any;
  emailRef: any;
  phoneRef: any;
}

function ContactInfo({
  initialInfo,
  onBlur,
  formProblems,
  emailRef,
  phoneRef,
}: Props) {
  const [email, setEmail] = React.useState(initialInfo.email);
  const [phone, setPhone] = React.useState(initialInfo.phone);
  const { email: emailProblem, phone: phoneProblem } = {
    email: prop(formProblems, 'billing_address.person.email'),
    phone: prop(formProblems, 'billing_address.person.phone'),
  };

  const handleBlur = () => {
    onBlur({ email, phone });
  };

  return (
    <Wrapper>
      <FormInput
        inputRef={emailRef}
        name={'email'}
        type="email"
        label={'Email'}
        value={email}
        required={true}
        marginBottom={16}
        marginRight={32}
        minWidthPx={288}
        // tslint:disable-next-line:jsx-no-lambda
        onChange={e => setEmail(e.target.value)}
        onBlur={handleBlur}
        validMessage={emailProblem}
      />
      <FormInput
        inputRef={phoneRef}
        name={'phone'}
        type="text"
        required={true}
        label={'Tel. číslo'}
        value={phone}
        marginBottom={16}
        minWidthPx={288}
        // tslint:disable-next-line:jsx-no-lambda
        onChange={e => setPhone(e.target.value)}
        onBlur={handleBlur}
        validMessage={phoneProblem}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: -${rem(16)};
`;

export { ContactInfo };
